module.exports = __webpack_public_path__ + "static/img/10areaA_03.17d24e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/10areaA_03.png
// module id = 792
// module chunks = 1